/** Variant-specific media for the native purchase box and theme gallery. */
(function () {
  "use strict";
  if (window.__tnProductVariantGalleryLoaded) return;
  window.__tnProductVariantGalleryLoaded = true;

  function normalizeMediaId(value) {
    var text = String(value || "");
    return text.slice(text.lastIndexOf("/") + 1);
  }

  function imageKey(value) {
    if (!value) return "";
    try {
      return new URL(
        String(value),
        window.location.href,
      ).pathname.toLowerCase();
    } catch (_error) {
      return String(value).split("?")[0].toLowerCase();
    }
  }

  function readVariantGalleryConfig(host) {
    var productId = host.getAttribute("data-product-id");
    if (!productId) return null;
    var scope = host.closest(".shopify-section") || document;
    var script = scope.querySelector(
      'script[data-product-variant-gallery][data-product-id="' +
        productId +
        '"]',
    );
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || "{}");
    } catch (_error) {
      return null;
    }
  }

  function findGallery(host, productId) {
    var scope = host.closest(".shopify-section") || document;
    return scope.querySelector(
      'media-gallery[data-product-id="' + productId + '"]',
    );
  }

  function setGalleryNodeVisible(node, visible) {
    if (!node) return;
    node.hidden = !visible;
    if (visible) node.removeAttribute("hidden");
  }

  function mediaEntryMatchesNode(entry, node) {
    if (!entry || !node) return false;
    var entryMediaId = normalizeMediaId(entry.mediaId);
    var nodeMediaId = normalizeMediaId(node.getAttribute("data-media-id"));
    if (entryMediaId && nodeMediaId) return entryMediaId === nodeMediaId;

    var targetImageKey = imageKey(entry.image);
    var image = node.querySelector("img.product-media__image, img");
    return (
      !!targetImageKey &&
      imageKey(image && (image.currentSrc || image.src)) === targetImageKey
    );
  }

  function getDesiredGalleryMedia(config, variant) {
    var assignedMediaIds = (config.assignedMediaIds || []).map(
      normalizeMediaId,
    );
    var productMedia = config.productMedia || [];
    var variantImages = variant.images || [];
    var sharedImages = productMedia.filter(function (entry) {
      return (
        assignedMediaIds.indexOf(normalizeMediaId(entry && entry.mediaId)) ===
        -1
      );
    });
    var hasVariantSlots = productMedia.some(function (entry) {
      return (
        assignedMediaIds.indexOf(normalizeMediaId(entry && entry.mediaId)) !==
        -1
      );
    });
    var entries = [];

    if (hasVariantSlots) {
      var variantImageIndex = 0;

      // Product media supplies the gallery's slot order. Replace each assigned
      // slot with the current variant's image at the same ordinal, while shared
      // media (for example Energy Drink's video at index 2) keeps its index.
      productMedia.forEach(function (entry) {
        var isVariantSlot =
          assignedMediaIds.indexOf(normalizeMediaId(entry && entry.mediaId)) !==
          -1;
        if (isVariantSlot) {
          if (variantImages[variantImageIndex]) {
            entries.push(variantImages[variantImageIndex]);
            variantImageIndex++;
          }
          return;
        }

        entries.push(entry);
      });

      entries = entries.concat(variantImages.slice(variantImageIndex));
    } else {
      // Keep the original behavior when product media provides no variant
      // slots from which an index can be inferred.
      entries = variantImages.concat(sharedImages);
    }

    return entries.reduce(function (result, entry) {
      if (!entry || (!entry.mediaId && !entry.image)) return result;
      var key = normalizeMediaId(entry.mediaId) || imageKey(entry.image);
      if (
        !key ||
        result.some(function (item) {
          return item.key === key;
        })
      ) {
        return result;
      }
      result.push({ key: key, entry: entry });
      return result;
    }, []);
  }

  function findOrderedNodes(nodes, desiredMedia) {
    return desiredMedia
      .map(function (item) {
        return nodes.find(function (node) {
          return mediaEntryMatchesNode(item.entry, node);
        });
      })
      .filter(Boolean);
  }

  function galleryMatchesDesiredMedia(gallery, desiredMedia) {
    var visibleSlides = Array.prototype.filter.call(
      gallery.querySelectorAll("slideshow-slide"),
      function (slide) {
        return !slide.hidden;
      },
    );
    if (visibleSlides.length !== desiredMedia.length) return false;

    return desiredMedia.every(function (item, index) {
      return mediaEntryMatchesNode(item.entry, visibleSlides[index]);
    });
  }

  function moveNodesToFront(nodes) {
    if (!nodes.length || !nodes[0].parentNode) return;
    var parent = nodes[0].parentNode;
    var fragment = document.createDocumentFragment();
    nodes.forEach(function (node) {
      if (node.parentNode === parent) fragment.appendChild(node);
    });
    parent.insertBefore(fragment, parent.firstChild);
  }

  function filterAndOrderNodes(nodes, desiredMedia) {
    var orderedNodes = findOrderedNodes(nodes, desiredMedia);
    nodes.forEach(function (node) {
      setGalleryNodeVisible(node, orderedNodes.indexOf(node) !== -1);
    });
    moveNodesToFront(orderedNodes);
    return orderedNodes;
  }

  function selectGalleryControlMedia(gallery, control, event) {
    var mediaId = normalizeMediaId(
      control && control.getAttribute("data-media-id"),
    );
    if (!mediaId) return;

    var visibleSlides = Array.prototype.filter.call(
      gallery.querySelectorAll("slideshow-slide[data-media-id]"),
      function (slide) {
        return !slide.hidden;
      },
    );
    var targetIndex = visibleSlides.findIndex(function (slide) {
      return normalizeMediaId(slide.getAttribute("data-media-id")) === mediaId;
    });
    if (targetIndex < 0) return;

    event.preventDefault();
    event.stopPropagation();

    gallery.querySelectorAll("slideshow-controls").forEach(function (controls) {
      var visibleControls = Array.prototype.filter.call(
        controls.querySelectorAll(
          '.slideshow-controls__thumbnail[data-media-id], [ref="dots[]"][data-media-id]',
        ),
        function (item) {
          return !item.hidden && !(item.closest("li") || item).hidden;
        },
      );
      visibleControls.forEach(function (item) {
        item.setAttribute(
          "aria-selected",
          String(
            normalizeMediaId(item.getAttribute("data-media-id")) === mediaId,
          ),
        );
      });

      controls
        .querySelectorAll(".slideshow-controls__counter")
        .forEach(function (counter) {
          var current = counter.querySelector('[ref="current"]');
          if (current) current.textContent = String(targetIndex + 1);
        });
    });

    var slideshow =
      (gallery.refs && gallery.refs.slideshow) ||
      gallery.querySelector("slideshow-component");
    if (!slideshow || typeof slideshow.select !== "function") return;
    if (typeof slideshow.updatedCallback === "function") {
      slideshow.updatedCallback();
    }

    // The native infinite-slide transition temporarily moves non-adjacent
    // slides. That conflicts with our hidden variant slides and snaps back to
    // image 1. An instant native selection preserves the requested index.
    slideshow.select(targetIndex, event, { animate: false });
  }

  function wireGalleryControl(gallery, control) {
    control.removeAttribute("on:click");
    if (control.getAttribute("data-purchase-gallery-control") === "true")
      return;
    control.setAttribute("data-purchase-gallery-control", "true");
    control.addEventListener("click", function (event) {
      selectGalleryControlMedia(gallery, control, event);
    });
  }

  function syncSlideshowControls(gallery, desiredMedia, selectedIndex) {
    gallery.querySelectorAll("slideshow-controls").forEach(function (controls) {
      var thumbnails = Array.prototype.slice.call(
        controls.querySelectorAll(
          ".slideshow-controls__thumbnail[data-media-id]",
        ),
      );
      thumbnails.forEach(function (thumbnail) {
        thumbnail.setAttribute("aria-selected", "false");
      });
      filterAndOrderNodes(thumbnails, desiredMedia).forEach(
        function (thumbnail, index) {
          wireGalleryControl(gallery, thumbnail);
          thumbnail.setAttribute(
            "aria-label",
            "Slide " + (index + 1) + " of " + desiredMedia.length,
          );
          thumbnail.setAttribute(
            "aria-selected",
            String(index === selectedIndex),
          );
        },
      );

      var dots = Array.prototype.slice.call(
        controls.querySelectorAll('[ref="dots[]"][data-media-id]'),
      );
      dots.forEach(function (dot) {
        dot.setAttribute("aria-selected", "false");
      });
      var orderedDots = findOrderedNodes(dots, desiredMedia);
      dots.forEach(function (dot) {
        setGalleryNodeVisible(
          dot.closest("li") || dot,
          orderedDots.indexOf(dot) !== -1,
        );
      });
      moveNodesToFront(
        orderedDots.map(function (dot) {
          return dot.closest("li") || dot;
        }),
      );
      orderedDots.forEach(function (dot, index) {
        wireGalleryControl(gallery, dot);
        dot.setAttribute(
          "aria-label",
          "Slide " + (index + 1) + " of " + desiredMedia.length,
        );
        dot.setAttribute("aria-selected", String(index === selectedIndex));
      });

      controls
        .querySelectorAll(".slideshow-controls__counter")
        .forEach(function (counter) {
          var current = counter.querySelector('[ref="current"]');
          if (current) current.textContent = String(selectedIndex + 1);
          var total = counter.lastChild;
          if (total && total.nodeType === Node.TEXT_NODE) {
            total.nodeValue = String(desiredMedia.length);
          }
        });
    });
  }

  function syncZoomGallery(gallery, desiredMedia, selectedIndex) {
    var zoomItems = Array.prototype.slice.call(
      gallery.querySelectorAll(".dialog-zoomed-gallery > li[data-media-id]"),
    );
    filterAndOrderNodes(zoomItems, desiredMedia);

    var zoomThumbnails = Array.prototype.slice.call(
      gallery.querySelectorAll(
        ".dialog-thumbnails-list__thumbnail[data-media-id]",
      ),
    );
    filterAndOrderNodes(zoomThumbnails, desiredMedia).forEach(
      function (thumbnail, index) {
        thumbnail.setAttribute("on:click", "/handleThumbnailClick/" + index);
        thumbnail.setAttribute(
          "on:pointerenter",
          "/handleThumbnailPointerEnter/" + index,
        );
        thumbnail.setAttribute(
          "aria-selected",
          String(index === selectedIndex),
        );
      },
    );
  }

  function selectVariantGalleryMedia(block, variant) {
    if (!variant || !(variant.images || []).length) return;

    var config = readVariantGalleryConfig(block);
    var gallery = config && findGallery(block, config.productId);
    if (!gallery) return;

    var desiredMedia = getDesiredGalleryMedia(config, variant);
    if (!desiredMedia.length) return;

    // Keep Liquid's initial gallery intact when it already matches the selection.
    var galleryStateKey = [
      config.market || "",
      String(variant.id || ""),
      desiredMedia
        .map(function (item) {
          return item.key;
        })
        .join(","),
    ].join(":");
    if (galleryMatchesDesiredMedia(gallery, desiredMedia)) {
      block.__purchaseGalleryState = {
        key: galleryStateKey,
        gallery: gallery,
      };
      return;
    }

    var slideshow =
      (gallery.refs && gallery.refs.slideshow) ||
      gallery.querySelector("slideshow-component");
    var allSlides = Array.prototype.slice.call(
      gallery.querySelectorAll("slideshow-slide"),
    );
    var orderedSlides = filterAndOrderNodes(allSlides, desiredMedia);
    if (!orderedSlides.length) return;
    var targetIndex = 0;
    orderedSlides.forEach(function (slide, index) {
      slide.setAttribute("aria-hidden", String(index !== targetIndex));
    });

    syncSlideshowControls(gallery, desiredMedia, targetIndex);
    filterAndOrderNodes(
      Array.prototype.slice.call(
        gallery.querySelectorAll(".media-gallery__grid > li[data-media-id]"),
      ),
      desiredMedia,
    );
    syncZoomGallery(gallery, desiredMedia, targetIndex);

    block.__purchaseGalleryState = {
      key: galleryStateKey,
      gallery: gallery,
    };

    if (!slideshow) return;
    if (typeof slideshow.updatedCallback === "function") {
      slideshow.updatedCallback();
    }
    if (typeof slideshow.select === "function") {
      window.requestAnimationFrame(function () {
        if (block.__purchaseGalleryState.key !== galleryStateKey) return;
        if (slideshow.current === targetIndex) slideshow.current = -1;
        slideshow.select(targetIndex, undefined, { animate: false });
      });
    }
  }

  document.addEventListener("purchase:change", function (event) {
    var host =
      event.target.closest && event.target.closest("product-purchase-box");
    if (!host) return;
    var config = readVariantGalleryConfig(host);
    if (!config) return;
    var variantId =
      event.detail && (event.detail.galleryVariantId || event.detail.variantId);
    var variant = (config.variants || []).find(function (item) {
      return String(item.id) === String(variantId);
    });
    if (variant) selectVariantGalleryMedia(host, variant);
  });
  document.dispatchEvent(new CustomEvent("purchase:gallery-ready"));
})();
